//Component Name
export const CURRENCY = "currency";
export const CURRENCY_FAILURE = "currency-failure";

export const CURRENCY_DETAILS = "currency-details";
export const CURRENCY_DETAILS_FAILURE = "currency-details-failure";

export const NEWS = "news";
export const NEWS_FAILURE = "news-failure";

export const COIN_HISTORY = "coin";
export const COIN_HISTORY_FAILURE = "coin-failure";

//Common
export const RESET_STATE = "reset-store";
export const CLEAR_STATUS = "clear-status";
export const SET_TAB = "set_tab";
